export default __webpack_public_path__ + "static/media/layer1.7ebf355e.svg";